import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML =
`<custom-style>
  <style>
    html {
      --type-base: {
        font-family: InspireTWDC, Helvetica, Arial, sans-serif;
      }

      --icon-font: {
        font-family: "pepmdx";
      }

      --type50: {
        font-size: 50px;
        line-height: 60px;
        font-weight: 100;
      }

      --type36: {
        font-size: 36px;
        line-height: 48px;
        font-weight: 100;
      }

      --type28: {
        font-size: 28px;
        line-height: 36px;
        font-weight: 100;
      }

      --type24: {
        font-size: 24px;
        line-height: 32px;
        font-weight: 100;
      }

      --type20: {
        font-size: 20px;
        line-height: 28px;
        font-weight: 100;
      }

      --type18: {
        font-size: 18px;
        line-height: 24px;
        font-weight: 400;
      }

      --type16: {
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
      }

      --type14: {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
      }

      --type12: {
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
      }

      --light: {
        font-weight: 100;
      }

      --roman: {
        font-weight: 400;
      }

      --heavy: {
        font-weight: 700;
      }

      --black: {
        font-weight: 900;
      }

      --oblique: {
        font-style: italic;
      }
    }
  </style>
</custom-style>`;

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
    `<template>
      <style>
      .type-base {
        @apply --type-base;
      }
      .type50 {
        @apply --type50;
      }
      .type36 {
        @apply --type36;
      }
      .type28 {
        @apply --type28;
      }
      .type24 {
        @apply --type24;
      }
      .type18 {
        @apply --type18;
      }
      .type16 {
        @apply --type16;
      }
      .type14 {
        @apply --type14;
      }
      .type12 {
        @apply --type12;
      }
      .heavy {
        @apply --heavy;
      }
      .black {
        @apply --black;
      }
      .oblique {
        @apply --oblique;
      }

      .header1 {
        @apply --type28;
        @apply --black;
      }

      .header2 {
        @apply --type24;
        @apply --black;
      }

      .header3 {
        @apply --type20;
        @apply --black;
      }

      .header4 {
        @apply --type18;
        @apply --black;
      }

      .header5 {
        @apply --type16;
        @apply --black;
      }

      .header6 {
        @apply --type16;
        @apply --heavy;
      }

      .header7 {
        @apply --type20;
        @apply --heavy;
      }

      .body1 {
        @apply --type14;
      }

      .body2,
      .body3,
      .body4 {
        @apply --type12;
      }

      .icon-font {
        @apply --icon-font;
      }

      .list {
        list-style-type: disc;
        margin: 20px 0 20px 20px;
      }

      /* Tablet Size Viewport */
      @media (min-width: 768px) and (max-width: 1199px) {
        .header1 {
          @apply --type36;
          @apply --black;
        }

        .header2 {
          @apply --type28;
          @apply --black;
        }

        .header3 {
          @apply --type24;
          @apply --black;
        }

        .header4 {
          @apply --type20;
          @apply --black;
        }

        .header5 {
          @apply --type18;
          @apply --heavy;
        }

        .body1 {
          @apply --type16;
        }

        .body2 {
          @apply --type14;
        }
      }

      /* Desktop Size Viewport */
      @media (min-width: 1200px) {
        .header1 {
          @apply --type50;
          @apply --black;
        }

        .header2 {
          @apply --type36;
          @apply --black;
        }

        .header3 {
          @apply --type28;
          @apply --black;
        }

        .header4 {
          @apply --type24;
          @apply --black;
        }

        .header5 {
          @apply --type20;
          @apply --black;
        }

        .body1 {
          @apply --type18;
        }

        .body2 {
          @apply --type16;
        }

        .body3 {
          @apply --type14;
        }
      }
    </style>
  </template>`;

  styleElement.register('com-theme-typography');
  document.head.appendChild($_documentContainer.content);